import Vue from 'vue'
import VueRouter from 'vue-router'
const Home = () => import('../views/Home.vue')
// const mHome = () => import('../views/sjHome.vue')
// const Personalnav = ()=> import('../views/personalnav.vue')
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      redirect: '/hyxw',
      children: [
        {
          path: '/hyxw',
          name: 'hyxw',
          component: () => import('../views/dataModel/hyxw.vue')
        }, {
          path: '/zcfg',
          name: 'zcfg',
          component: () => import('../views/dataModel/zcfg.vue')
        }, {
          path: '/xmdt',
          name: 'xmdt',
          component: () => import('../views/dataModel/xmdt.vue')
        }, {
          path: '/tzgg',
          name: 'tzgg',
          component: () => import('../views/dataModel/tzgg.vue')
        }, {
          path: '/newsItem/:id',
          name: 'newsItem',
          component: () => import('../views/dataModel/newsItem.vue')
        },]
    },
    // {
    //   path: '/mHome',
    //   name: 'mHome',
    //   component: mHome,
    // },
    {
      path: '/gsjj',
      name: 'gsjj',
      component: () => import('../views/CompanyProfile.vue')
    },
    {
      path: '/xxdt',
      name: 'xxdt',
      component: () => import('../views/InformationDynamics.vue'),
      redirect: '/hyxw1',
      children: [
        {
          path: '/hyxw1',
          name: 'hyxw1',
          component: () => import('../views/dataModel/hyxw.vue')
        }, {
          path: '/zcfg1',
          name: 'zcfg1',
          component: () => import('../views/dataModel/zcfg.vue')
        }, {
          path: '/xmdt1',
          name: 'xmdt1',
          component: () => import('../views/dataModel/xmdt.vue')
        }, {
          path: '/tzgg1',
          name: 'tzgg1',
          component: () => import('../views/dataModel/tzgg.vue')
        }, {
          path: '/newsItem1/:id',
          name: 'newsItem1',
          component: () => import('../views/dataModel/newsItem.vue')
        },]
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('../views/dataModel/searchNews.vue'),
      children: [{
        path: '/newsItem2/:id',
        name: 'newsItem2',
        component: () => import('../views/dataModel/newsItem.vue')
      },]
    },{
      path: '/Cooperation',
      name: 'Cooperation',
      component: () => import('../views/Cooperation.vue'),
    },{
      path: '/ContactUs',
      name: 'ContactUs',
      component: () => import('../views/ContactUs.vue'),
    },
    {
      path: '/*',
      name: '/404',
    }
  ]
})
//  每次路由跳转侧边导航栏回到顶部
// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0)
// })
// const routerReplace = VueRouter.prototype.replace
// VueRouter.prototype.replace = function (location) {
//   return routerReplace.call(this, location).catch(error => error)
// }
// router.afterEach((to, from, next) => {
//   document.documentElement.scrollTop = 0
//   document.body.scrollTop = 0
// })
// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }
router.afterEach((to, from, next) => {
  // console.log(to.path)
  if (to.path == '/gsjj'||to.path == '/vy'||to.path == '/mk'||to.path == '/yl') {
    window.scrollTo({
      top: 0
    })
  }
})
export default router
